import { useState } from 'react';
import useInsuranceCarriers, { IInsurancePlan } from 'src/hooks/useInsuranceCarriers';
import SearchDropDown from './SearchDropDown';

const InsuranceCarrierSearch = ({
  onChange,
  value,
}: {
  value?: string;
  onChange: (planToken: string, planName: string) => void;
}) => {
  const [searchValue, setSearchValue] = useState('');
  const { data: plans = [] } = useInsuranceCarriers();

  const handleInputChange = (value: string) => {
    const plan = plans?.find((plan) => plan.token === value);
    if (plan) {
      setSearchValue(plan.name);
    } else {
      setSearchValue(value);
    }
  };

  return (
    <SearchDropDown
      onChange={(_e, selectedItem) =>
        onChange((selectedItem as IInsurancePlan)?.token, (selectedItem as IInsurancePlan)?.name)
      }
      onInputChange={(_e, value) => handleInputChange(value)}
      options={plans}
      placeholder="Insurance plan name"
      searchString={searchValue}
      value={value}
      noOptionsText="No matches found. If your insurance carrier isn't listed, please select 'Other'."
    />
  );
};

export default InsuranceCarrierSearch;
